export function StatusPill({ connected }: { connected: boolean }) {
  return connected ? (
    <span className="rounded-full bg-emerald-50 dark:bg-emerald-950/40 px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider text-emerald-700 dark:text-emerald-300">
      Connected
    </span>
  ) : (
    <span className="rounded-full bg-zinc-100 dark:bg-surface-2 px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider text-zinc-500 dark:text-zinc-400">
      Not connected
    </span>
  );
}
